import {formatReferenceCopy} from 'utils/typography';
import React from "react";

import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import { ExpandMore as ExpandMoreIcon } from '@vedmarket/ui-kit';
import AccordionDetails from "@mui/material/AccordionDetails";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import {COLORS} from "../../../../../../../../../../../config/constants";

type Props = {
    item: DocumentsByCodeItems
    code: string
    index: number
    isActive: boolean
    isDisabled: boolean
    handleChangeSelectedGroup(index: number, code: string): void
}

const CertificationCodeCuTrOption = ({item, handleChangeSelectedGroup, isActive, index, isDisabled} : Props) => {

  const renderLabel = (isExpanded? : boolean) => {
    return <FormControlLabel
      checked={isActive}
      sx={{
        '.MuiFormControlLabel-label': {
          lineHeight: '21px',
          minWidth: 0,
        },
        width: '100%',
        alignItems: 'flex-start',
        margin: isExpanded ? '16px 0' : '16px 0 0',
        ...( !isExpanded && {
          paddingBottom: '16px',
          borderBottom: `1px solid ${COLORS.SLIGHTLY_GRAY}`,
        }),
      }}
      control={<Checkbox sx={{
        padding: 0,
        marginRight: '8px',
      }}/>}
      disabled={isDisabled}
      onChange={() => handleChangeSelectedGroup(index, item.group.code)}
      label={<Typography variant='body2' sx={{lineHeight: '21px'}}>{formatReferenceCopy(item.group.name)}</Typography>}
    />
  }

  if (!item.notes.note) {
    return renderLabel();
  }

  return <>
    <Accordion sx={{
      backgroundColor: 'transparent',
      boxShadow: 'none',
      marginBottom: 0,
      '&.Mui-expanded': {
        marginBottom: 0,
      },
      borderBottom: `1px solid ${COLORS.SLIGHTLY_GRAY}`,
    }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          padding: 0,
          minHeight: '68px',
          '&.Mui-expanded': {
            borderBottom: 'none',
            minHeight: '68px',
            '.MuiAccordionSummary-content': {
              margin: '0',
            }
          },
          '.MuiAccordionSummary-expandIconWrapper': {
            alignSelf: 'flex-start',
            marginTop: '16px',
            marginLeft: '16px',
            color: COLORS.LIGHT_ACTION,
          },
          '.MuiAccordionSummary-expandIconWrapper svg': {
            width: '24px',
            height: '24px',
          },
          '.MuiAccordionSummary-content': {
            margin: '0',
          }
        }}
      >
        {renderLabel(true)}
      </AccordionSummary>
      <AccordionDetails sx={{
        padding: '0 0 24px 32px',
      }}>
        <Typography variant='body2' sx={{
          color: isDisabled ? COLORS.LIGHT_TEXT_DISABLED_OPACITY : COLORS.BLACK_DARK,
          lineHeight: '21px',
        }}>
          {formatReferenceCopy(item.notes.note)}
        </Typography>
      </AccordionDetails>
    </Accordion>
  </>
}

export default CertificationCodeCuTrOption
